import { render, staticRenderFns } from "./BitacoraHistory.vue?vue&type=template&id=5985c891&scoped=true"
import script from "./BitacoraHistory.vue?vue&type=script&lang=js"
export * from "./BitacoraHistory.vue?vue&type=script&lang=js"
import style0 from "./BitacoraHistory.vue?vue&type=style&index=0&id=5985c891&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985c891",
  null
  
)

export default component.exports